<template>
  <div class="page-container">
    <div class="tag-tabs-bar" style="display:flex;gap:0;border-bottom:1px solid #e8ecf2;margin-bottom:16px;">
      <button class="tag-tab-btn" :class="{active:activeTab==='groups'}" @click="activeTab='groups'">标签分组</button>
      <button class="tag-tab-btn" :class="{active:activeTab==='logs'}" @click="activeTab='logs'">事件日志</button>
    </div>

    <!-- 事件日志 Tab -->
    <div v-if="activeTab==='logs'">
      <div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:16px;padding:12px;background:#fafafa;border-radius:4px;">
        <el-select v-model="logFilter.actionType" placeholder="全部操作类型" clearable size="small" style="width:140px;">
          <el-option label="创建标签" :value="1"></el-option><el-option label="编辑标签" :value="2"></el-option>
          <el-option label="启用标签" :value="3"></el-option><el-option label="禁用标签" :value="4"></el-option>
          <el-option label="删除标签" :value="5"></el-option>
        </el-select>
        <el-input v-model="logFilter.tagName" placeholder="标签名称" clearable size="small" style="width:140px;"></el-input>
        <el-input v-model="logFilter.operator" placeholder="操作人" clearable size="small" style="width:140px;"></el-input>
        <el-date-picker v-model="logFilter.startDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" size="small" style="width:140px;"></el-date-picker>
        <el-date-picker v-model="logFilter.endDate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width:140px;"></el-date-picker>
        <el-button size="small" @click="resetLogFilter">重置</el-button>
        <el-button type="primary" size="small" @click="fetchEventLogs">搜索</el-button>
      </div>
      <div class="table-wrapper" style="background:#fff;padding:16px;border-radius:4px;">
        <el-table :data="eventLogs" border size="small" style="font-size:13px;">
          <el-table-column prop="operateTime" label="时间" width="170"></el-table-column>
          <el-table-column label="操作类型" width="120">
            <template slot-scope="scope">{{ actionTypeLabel(scope.row.actionType) }}</template>
          </el-table-column>
          <el-table-column prop="tagName" label="标签名称" width="150"></el-table-column>
          <el-table-column prop="operator" label="操作人" width="120"></el-table-column>
          <el-table-column prop="actionDetail" label="详情" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination @size-change="(v)=>{logPageSize=v;fetchEventLogs()}" @current-change="(v)=>{logPageNum=v;fetchEventLogs()}"
          :current-page="logPageNum" :page-sizes="[10,20,50]" :page-size="logPageSize" layout="total,sizes,prev,pager,next" :total="logTotal"></el-pagination>
      </div>
    </div>

    <!-- 标签分组 Tab -->
    <div v-if="activeTab==='groups'" class="tag-layout">
      <div class="tag-left">
        <div class="section-header">
          <span class="section-title">标签分组</span>
          <el-button v-auth="'business:tagManagement:save'" type="primary" size="mini" icon="el-icon-plus" @click="openTagDialog(null)">新建标签</el-button>
        </div>
        <div v-for="g in groups" :key="g.id" class="tag-group">
          <div class="group-header" @click="toggleGroup(g.id)" :class="{collapsed:!expandedGroups[g.id]}">
            {{ g.groupName }} <span class="arrow">▼</span>
          </div>
          <div class="group-items" :class="{collapsed:!expandedGroups[g.id]}">
            <div v-for="t in getTagsByGroup(g.id)" :key="t.id" class="tag-row" :class="{active:selectedTag && selectedTag.id===t.id}" @click="selectTag(t)" :style="{opacity:t.isDelete===2?0.5:1}">
              <span class="tag-txt"><span class="tag-dot" :style="{background:t.isDelete===1?(t.color||'#00d4aa'):'#9ca3af'}"></span>{{ t.tagName }}</span>
              <div style="display:flex;align-items:center;gap:10px;">
                <span class="tag-count" style="cursor: pointer;
    font-size: 12px;
    color: #27F30B;
    text-decoration: underline;" @click.stop="showTagCustomers(t)">{{ t.count || 0 }}</span>
                <label v-auth="'business:tagManagement:status'" class="switch" @click.stop>
                  <input type="checkbox" :checked="t.isDelete===1" @change="toggleTagStatus(t)">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tag-right">
        <div v-if="!selectedTag" class="empty-state">
          <div style="font-size:40px;">🏷️</div>
          <p>请从左侧选择一个标签查看详情</p>
        </div>
        <div v-if="selectedTag" class="detail-section">
          <div class="detail-title">标签信息</div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
            <div class="form-group"><label>标签ID</label><el-input :value="selectedTag.id" disabled size="small"></el-input></div>
            <div class="form-group"><label>标签名称</label><el-input v-model="selectedTag.tagName" size="small"></el-input></div>
            <div class="form-group"><label>所属分组</label><el-input :value="getGroupName(selectedTag.groupId)" disabled size="small"></el-input></div>
            <div class="form-group"><label>标签颜色</label><div class="tag-dialog-color"><el-color-picker v-model="selectedTag.color" size="small" color-format="hex"></el-color-picker></div></div>
            <div class="form-group">
              <label>状态</label><el-select v-model="selectedTag.isDelete" size="small" style="width:100%;">
                <el-option label="启用" :value="1"></el-option><el-option label="禁用" :value="2"></el-option>
              </el-select>
            </div>
            <div class="form-group" style="grid-column:span 2;">
              <label>标签描述</label><el-input type="textarea" v-model="selectedTag.description" :rows="2" size="small"></el-input>
            </div>
          </div>

          <!-- 打标规则 -->
          <div class="detail-section" style="margin-top:20px;padding-top:16px;border-top:1px solid #ebeef5;">
            <div class="detail-title" style="display:flex;align-items:center;justify-content:space-between;">
              <span>打标规则</span>
              <el-switch v-auth="'business:tagManagement:status'" v-model="tagRuleEnabled" active-color="var(--brand-primary)" inactive-color="#c0ccda" @change="toggleTagRuleEnabled"></el-switch>
            </div>
            <div v-if="!tagRuleEnabled" style="text-align:center;padding:24px;color:#909399;font-size:13px;">未开启打标规则</div>
            <div v-if="tagRuleEnabled">
              <div class="form-group" style="margin-bottom:12px;">
                <label>触发条件</label>
                <div style="display:flex;gap:8px;">
                  <el-select v-model="tagRule.conditionTypeForm" placeholder="条件类型" size="small" style="min-width:140px;" :disabled="tagRule.isJsonConfig===1">
                    <el-option v-for="c in conditionTypes" :key="c.code" :label="c.desc" :value="c.code"></el-option>
                  </el-select>
                  <el-select v-model="tagRule.conditionOperatorForm" size="small" style="min-width:100px;" :disabled="tagRule.isJsonConfig===1">
                    <el-option label="大于 (>)" value=">"></el-option><el-option label="大于等于 (>=)" value=">="></el-option>
                    <el-option label="小于 (<)" value="<"></el-option><el-option label="小于等于 (<=)" value="<="></el-option>
                    <el-option label="等于 (=)" value="="></el-option><el-option label="不等于 (!=)" value="!="></el-option>
                  </el-select>
                  <el-input v-model="tagRule.conditionValueForm" placeholder="阈值" size="small" style="flex:1;" :disabled="tagRule.isJsonConfig===1"></el-input>
                </div>
              </div>
              <div class="form-group" style="margin-bottom:12px;">
                <label>规则配置（JSON）</label>
                <el-input type="textarea" v-model="tagRule.jsonConfig" :rows="6" placeholder='{"conditions":[{"field":"deposit_amount","op":"gt","value":100000}],"action":"add_tag"}' style="font-family:monospace;font-size:12px;" size="small"></el-input>
              </div>
              <div class="form-group">
                <label>规则描述</label><el-input v-model="tagRule.description" size="small" placeholder="请输入规则描述"></el-input>
              </div>
              <div class="form-group">
                <el-checkbox v-model="tagRule.isJsonConfig" :true-label="1" :false-label="2">使用JSON模式（开启后将忽略上方表单条件，以JSON配置为准）</el-checkbox>
              </div>
            </div>
          </div>

          <!-- 操作记录 -->
          <div class="detail-section" style="margin-top:16px;padding-top:16px;border-top:1px solid #ebeef5;">
            <div class="detail-title">操作记录</div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
              <div class="form-group"><label>创建人</label><el-input :value="selectedTag.createUser||'-'" disabled size="small"></el-input></div>
              <div class="form-group"><label>创建时间</label><el-input :value="selectedTag.createDate||'-'" disabled size="small"></el-input></div>
              <div class="form-group"><label>最后更新人</label><el-input :value="selectedTag.updateUser||'-'" disabled size="small"></el-input></div>
              <div class="form-group"><label>最后更新时间</label><el-input :value="selectedTag.updateDate||'-'" disabled size="small"></el-input></div>
            </div>
          </div>

          <div style="margin-top:16px;display:flex;gap:8px;">
            <el-button v-auth="'business:tagManagement:edit'" type="primary" size="small" @click="saveTagDetail">保存修改</el-button>
            <el-button v-auth="'business:tagManagement:delete'" size="small" @click="deleteTag(selectedTag)">删除标签</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 标签弹窗 -->
    <el-dialog :title="tagDialogTitle" :visible.sync="tagDialogVisible" width="700px" :close-on-click-modal="false">
      <div class="detail-section" style="margin-bottom:16px;padding:0;border:none;">
        <div class="detail-title">标签基础信息</div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
          <div class="form-group">
            <label>标签名称 <span style="color:#f56c6c;">*</span></label>
            <el-input v-model="tagForm.tagName" size="small" placeholder="请输入标签名称"></el-input>
          </div>
          <div class="form-group">
            <label>所属分组 <span style="color:#f56c6c;">*</span></label>
            <el-select v-model="tagForm.groupId" size="small" style="width:100%;">
              <el-option v-for="g in groups" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label>标签颜色</label>
            <div class="tag-dialog-color"><el-color-picker v-model="tagForm.color" size="small" color-format="hex"></el-color-picker></div>
          </div>
          <div class="form-group" style="grid-column:span 2;">
            <label>标签描述</label>
            <el-input type="textarea" v-model="tagForm.description" size="small" placeholder="请输入标签描述" :rows="3"></el-input>
          </div>
        </div>
      </div>

      <!-- 打标规则 -->
      <div class="detail-section" style="padding:0;border:none;">
        <div class="detail-title" style="display:flex;align-items:center;justify-content:space-between;">
          <span>打标规则</span>
          <el-switch v-model="tagRuleEnabledInDialog" active-color="var(--brand-primary)" inactive-color="#c0ccda"></el-switch>
        </div>
        <div v-if="!tagRuleEnabledInDialog" style="text-align:center;padding:20px;color:#909399;font-size:13px;">未开启打标规则</div>
        <div v-if="tagRuleEnabledInDialog">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
            <div class="form-group" style="grid-column:span 2;">
              <label>触发条件 <span style="color:#f56c6c;">*</span></label>
              <div style="display:flex;gap:8px;">
                <el-select v-model="tagDialogRule.conditionTypeForm" placeholder="请选择条件类型" size="small" style="min-width:140px;" :disabled="tagDialogRule.isJsonConfig===1">
                  <el-option v-for="c in conditionTypes" :key="c.code" :label="c.desc" :value="c.code"></el-option>
                </el-select>
                <el-select v-model="tagDialogRule.conditionOperatorForm" size="small" style="min-width:100px;" :disabled="tagDialogRule.isJsonConfig===1">
                  <el-option label="大于 (>)" value=">"></el-option><el-option label="大于等于 (>=)" value=">="></el-option>
                  <el-option label="小于 (<)" value="<"></el-option><el-option label="小于等于 (<=)" value="<="></el-option>
                  <el-option label="等于 (=)" value="="></el-option><el-option label="不等于 (!=)" value="!="></el-option>
                </el-select>
                <el-input v-model="tagDialogRule.conditionValueForm" size="small" placeholder="阈值，如 100000" style="flex:1;" :disabled="tagDialogRule.isJsonConfig===1"></el-input>
              </div>
            </div>
            <div class="form-group" style="grid-column:span 2;">
              <label>规则配置（JSON）</label>
              <el-input type="textarea" v-model="tagDialogRule.jsonConfig" size="small" :rows="8" placeholder='{"conditions":[{"field":"deposit_amount","op":">","value":100000}],"action":"add_tag"}' style="font-family:monospace;font-size:12px;"></el-input>
            </div>
            <div class="form-group" style="grid-column:span 2;">
              <el-checkbox v-model="tagDialogRule.isJsonConfig" :true-label="1" :false-label="2">使用JSON模式（开启后将忽略上方表单条件，以JSON配置为准）</el-checkbox>
            </div>
            <div class="form-group" style="grid-column:span 2;">
              <label>规则描述</label>
              <el-input type="textarea" v-model="tagDialogRule.description" size="small" placeholder="请输入规则描述，说明规则的触发场景和目的" :rows="2"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer"><el-button @click="tagDialogVisible=false">取消</el-button><el-button v-auth="'business:tagManagement:save'" type="primary" @click="saveTagFromDialog">保存</el-button></div>
    </el-dialog>

    <!-- 标签客户列表弹窗 -->
    <el-dialog :title="customerModalTitle" :visible.sync="customerModalVisible" width="900px" :close-on-click-modal="false">
      <div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:12px;">
        <el-input v-model="customerFilter.id" placeholder="用户ID" clearable size="small" style="width:140px;"></el-input>
        <el-input v-model="customerFilter.name" placeholder="姓名" clearable size="small" style="width:140px;"></el-input>
        <el-date-picker v-model="customerFilter.startDate" type="date" placeholder="标记开始" value-format="yyyy-MM-dd" size="small" style="width:140px;"></el-date-picker>
        <el-date-picker v-model="customerFilter.endDate" type="date" placeholder="标记结束" value-format="yyyy-MM-dd" size="small" style="width:140px;"></el-date-picker>
        <el-button size="small" @click="resetCustomerFilter">重置</el-button>
        <el-button type="primary" size="small" @click="fetchTaggedCustomers">搜索</el-button>
      </div>
      <el-table :data="taggedCustomers" border size="small">
        <el-table-column prop="customerNo" label="用户ID" width="120"></el-table-column>
        <el-table-column prop="name" label="姓名" width="120"></el-table-column>
        <el-table-column label="余额(USD)" width="130"><template slot-scope="s">{{ (s.row.balance||0).toFixed(2) }}</template></el-table-column>
        <el-table-column label="净值(USD)" width="130"><template slot-scope="s">{{ (s.row.equity||0).toFixed(2) }}</template></el-table-column>
        <el-table-column prop="regTime" label="注册时间" width="160"></el-table-column>
        <el-table-column label="操作" width="80"><template slot-scope="s"><el-button v-auth="'business:tagManagement:remove'" type="text" size="small" style="color:#f56c6c;" @click="removeTagCustomer(s.row)">移除</el-button></template></el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{customerPageSize=v;fetchTaggedCustomers()}" @current-change="(v)=>{customerPageNum=v;fetchTaggedCustomers()}"
        :current-page="customerPageNum" :page-sizes="[10,20,50]" :page-size="customerPageSize" layout="total,sizes,prev,pager,next" :total="customerTotal"></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { tagGroupAll, tagListAll, tagSave, tagDelete, tagRuleList, tagRuleSave, tagRuleDelete, tagEventLogList, tagTaggedCustomers } from '@/api/tagManagement'

export default {
  name: 'TagManagement',
  data() {
    return {
      activeTab: 'groups',
      groups: [], expandedGroups: {}, allTags: [],
      selectedTag: null, selectedRule: null,
      tagDialogVisible: false, tagDialogTitle: '新建标签',
      tagForm: { id: null, tagName: '', color: '#00d4aa', groupId: null, description: '' },
      tagRule: { id: null, ruleName: '', conditionTypeForm: null, conditionOperatorForm: '>=', conditionValueForm: '', tagId: null, status: 1, description: '', jsonConfig: '', isJsonConfig: 2 },
      tagRuleEnabled: false, tagRuleEnabledInDialog: false,
      tagDialogRule: { id: null, conditionTypeForm: null, conditionOperatorForm: '>=', conditionValueForm: '', description: '', jsonConfig: '', isJsonConfig: 2 },
      conditionTypes: [{code:1,desc:'入金金额'},{code:2,desc:'出金金额'},{code:3,desc:'浮动亏损'},{code:4,desc:'无交易天数'},{code:5,desc:'KYC状态'},{code:6,desc:'账户余额'},{code:7,desc:'登录频率'}],
      eventLogs: [], logTotal: 0, logPageNum: 1, logPageSize: 10,
      logFilter: { actionType: null, tagName: '', operator: '', startDate: null, endDate: null },
      customerModalVisible: false, customerModalTitle: '', currentTagId: null,
      taggedCustomers: [], customerTotal: 0, customerPageNum: 1, customerPageSize: 10,
      customerFilter: { id: '', name: '', startDate: null, endDate: null }
    }
  },
  mounted() { this.fetchGroups(); this.fetchEventLogs() },
  methods: {
    fetchGroups() {
      tagGroupAll().then(res => {
        if (res.code === 0) { this.groups = res.result || []; this.groups.forEach(g => { this.$set(this.expandedGroups, g.id, true) }) }
        tagListAll().then(r => { if (r.code === 0) this.allTags = r.result || [] })
      })
    },
    getTagsByGroup(gid) { return this.allTags.filter(t => t.groupId === gid) },
    toggleGroup(gid) { this.$set(this.expandedGroups, gid, !this.expandedGroups[gid]) },
    getGroupName(gid) { const g = this.groups.find(x => x.id === gid); return g ? g.groupName : '' },

    selectTag(t) {
      this.selectedTag = JSON.parse(JSON.stringify(t))
      // 查询关联的触发规则
      tagRuleList({ pageNum: 1, pageSize: 1, tagId: t.id }).then(res => {
        if (res.code === 0 && res.result && res.result.list && res.result.list.length > 0) {
          this.tagRule = JSON.parse(JSON.stringify(res.result.list[0]))
          this.tagRuleEnabled = true
        } else {
          this.tagRule = { id: null, ruleName: '', conditionTypeForm: null, conditionOperatorForm: '>=', conditionValueForm: '', tagId: t.id, status: 1, description: '', jsonConfig: '', isJsonConfig: 2 }
          this.tagRuleEnabled = false
        }
      })
    },
    toggleTagStatus(t) {
      const newVal = t.isDelete === 1 ? 2 : 1
      tagSave({ id: t.id, isDelete: newVal }).then(res => {
        if (res.code === 0) { t.isDelete = newVal; this.$message.success(newVal === 1 ? '已启用' : '已禁用'); this.fetchEventLogs() }
      })
    },
    openTagDialog(t) {
      if (t) { this.tagDialogTitle = '编辑标签'; this.tagForm = { ...t }; this.tagRuleEnabledInDialog = false }
      else {
        this.tagDialogTitle = '新建标签'; this.tagRuleEnabledInDialog = false
        this.tagForm = { id: null, tagName: '', color: '#00d4aa', groupId: this.groups.length > 0 ? this.groups[0].id : null, description: '' }
        this.tagDialogRule = { id: null, conditionTypeForm: null, conditionOperatorForm: '>=', conditionValueForm: '', description: '', jsonConfig: '', isJsonConfig: 2 }
      }
      this.tagDialogVisible = true
    },
    saveTagFromDialog() {
      if (!this.tagForm.tagName) { this.$message.warning('请输入标签名称'); return }
      const data = { ...this.tagForm }
      if (this.tagRuleEnabledInDialog && this.tagDialogRule.conditionTypeForm) {
        data.ruleData = JSON.stringify({ ...this.tagDialogRule, ruleName: this.tagForm.tagName, status: 1 })
      }
      tagSave(data).then(res => {
        if (res.code === 0) { this.$message.success('保存成功'); this.tagDialogVisible = false; this.fetchGroups(); this.fetchEventLogs() }
      })
    },
    saveTagDetail() {
      if (!this.selectedTag.tagName) { this.$message.warning('请输入标签名称'); return }
      const data = { ...this.selectedTag }
      if (this.tagRuleEnabled && this.tagRule.conditionTypeForm) {
        const rule = { ...this.tagRule, tagId: this.selectedTag.id, ruleName: this.tagRule.ruleName || this.selectedTag.tagName }
        data.ruleData = JSON.stringify(rule)
      } else if (!this.tagRuleEnabled && this.tagRule.id) {
        data.ruleDelete = this.tagRule.id
      }
      tagSave(data).then(res => {
        if (res.code === 0) { this.$message.success('保存成功'); this.fetchGroups(); this.fetchEventLogs(); this.selectTag(this.selectedTag) }
      })
    },
    toggleTagRuleEnabled(v) {
      const enabled = !!v
      this.tagRuleEnabled = enabled
      if (this.tagRule.id) {
        this.tagRule.status = enabled ? 1 : 2
        tagRuleSave(this.tagRule).then(() => {})
      } else if (enabled) {
        this.tagRule.tagId = this.selectedTag.id; this.tagRule.status = 1
      }
    },
    deleteTag(t) {
      this.$confirm('确定删除该标签?', '提示', { type: 'warning' }).then(() => {
        tagDelete(String(t.id)).then(res => { if (res.code === 0) { this.$message.success('删除成功'); this.selectedTag = null; this.fetchGroups(); this.fetchEventLogs() } })
      }).catch(() => {})
    },
    // 事件日志
    fetchEventLogs() {
      tagEventLogList({ pageNum: this.logPageNum, pageSize: this.logPageSize, ...this.logFilter }).then(res => {
        if (res.code === 0) { this.eventLogs = (res.result && res.result.list) ? res.result.list : []; this.logTotal = (res.result && res.result.total) ? res.result.total : 0 }
      })
    },
    resetLogFilter() { this.logFilter = { actionType: null, tagName: '', operator: '', startDate: null, endDate: null }; this.fetchEventLogs() },
    actionTypeLabel(t) { const m = { 1: '创建标签', 2: '编辑标签', 3: '启用标签', 4: '禁用标签', 5: '删除标签' }; return m[t] || t },
    showTagCustomers(t) {
      this.currentTagId = t.id; this.customerModalTitle = t.tagName + ' - 已标记客户（' + (t.count || 0) + '）'
      this.customerPageNum = 1; this.customerFilter = { id: '', name: '', startDate: null, endDate: null }
      this.customerModalVisible = true; this.fetchTaggedCustomers()
    },
    fetchTaggedCustomers() {
      tagTaggedCustomers({ tagId: this.currentTagId, pageNum: this.customerPageNum, pageSize: this.customerPageSize, customerId: this.customerFilter.id, customerName: this.customerFilter.name, startDate: this.customerFilter.startDate, endDate: this.customerFilter.endDate }).then(res => {
        if (res.code === 0) { this.taggedCustomers = (res.result && res.result.list) ? res.result.list : []; this.customerTotal = (res.result && res.result.total) ? res.result.total : 0 }
      })
    },
    resetCustomerFilter() { this.customerFilter = { id: '', name: '', startDate: null, endDate: null }; this.fetchTaggedCustomers() },
    removeTagCustomer(row) {
      this.$confirm('确定移除该客户的标签吗？', '确认移除', { type: 'warning' }).then(() => {
        this.$message.success('已移除'); this.fetchTaggedCustomers()
      })
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; background: #f5f7fa; min-height: calc(100vh - 84px); }
.tag-tabs-bar { background: #fff; border-radius: 4px 4px 0 0; padding: 0 16px; }
.tag-tab-btn { padding: 10px 20px; font-size: 13px; font-weight: 500; cursor: pointer; border: none; background: none; color: #909399; border-bottom: 2px solid transparent; }
.tag-tab-btn.active { color: var(--brand-primary); border-bottom-color: var(--brand-primary); }
.tag-layout { display: flex; gap: 16px; }
.tag-left { width: 320px; min-width: 320px; background: #fff; border-radius: 4px; padding: 16px; }
.tag-right { flex: 1; background: #fff; border-radius: 4px; padding: 20px; min-height: 500px; }
.section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.section-title { font-size: 14px; font-weight: 600; }
.tag-group { margin-bottom: 8px; }
.group-header { display: flex; align-items: center; justify-content: space-between; padding: 8px 0; cursor: pointer; font-size: 13px; font-weight: 600; color: #909399; border-bottom: 1px solid #ebeef5; }
.group-header:hover { color: #303133; }
.group-header .arrow { transition: transform 0.2s; font-size: 10px; }
.group-header.collapsed .arrow { transform: rotate(-90deg); }
.group-items { padding: 4px 0; }
.group-items.collapsed { display: none; }
.tag-row { display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; cursor: pointer; border-radius: 4px; margin-bottom: 2px; }
.tag-row:hover { background: #f0f2f5; }
.tag-row.active { background: var(--brand-primary-light); }
.tag-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.tag-txt { display: flex; align-items: center; gap: 8px; font-size: 13px; }
.empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; color: #909399; }
.detail-section { padding: 8px 0; }
.detail-title { font-size: 14px; font-weight: 600; margin-bottom: 16px; padding-bottom: 8px; border-bottom: 1px solid #ebeef5; }
.form-group { margin-bottom: 12px; }
.form-group label { display: block; font-size: 13px; color: #606266; margin-bottom: 6px; }
.tag-dialog-color /deep/ .el-color-picker__trigger { width: 100%; height: 38px; }
.tag-dialog-color /deep/ .el-color-picker { width: 100%; }
.switch { position: relative; display: inline-block; width: 36px; height: 20px; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider { position: absolute; cursor: pointer; inset: 0; background: #ccc; border-radius: 20px; transition: .3s; }
.slider:before { content: ""; position: absolute; height: 16px; width: 16px; left: 2px; bottom: 2px; background: #fff; border-radius: 50%; transition: .3s; }
.switch input:checked + .slider { background: var(--brand-primary); }
.switch input:checked + .slider:before { transform: translateX(16px); }
</style>
